import {Platform} from 'react-native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';

import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.View`
  flex: 1;

  align-items: center;
  margin: 0 24px;
`;

export const TitlesContainer = styled.View`
  margin: 0 24px;
`;

export const IconContainer = styled.View`
  width: ${RFValue(60)}px;
  height: ${RFValue(60)}px;
  background-color: ${({theme}) => theme.colors.background};
  justify-content: center;
  align-items: center;
  margin-bottom: ${RFValue(20)}px;
  border-radius: ${RFValue(16)}px;
`;

export const Section = styled.ScrollView`
  padding: 0 24px;
  margin: 0 -24px;
`;

export const List = styled.View`
  flex: 1;
`;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(12)}px;
`;

export const SectionTitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;

export const Footer = styled.View`
  padding: 0 24px;
  margin-top: ${RFValue(6)}px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? 0
    : RFValue(20)}px;
`;
export const CameraView = styled.View`
  flex: 1;
`;
